import React, { useState } from 'react'
import {CopyText, Email, ImageBuffer} from '../..';
import { copy } from '../../../assets';

import './banner.css'

const Banner = () => {
  const email = "admin@gloriaserenityhomehealth.net";

  return (
    <>
      <div className="banner-wrapper">
        <CopyText text={email} />
      </div>
    </>
  )
}

export default Banner